import React from 'react';

import { Button } from '../../components/ui';

export function LookbookTopButtons({ onNext, className = '' }) {
  return (
    <div className={className}>
      <Button
        variant="primary"
        size="xl"
        className="rc-lb-next-btn"
        onClick={onNext}
      >
        Next
      </Button>
    </div>
  );
}
